import { render, staticRenderFns } from "./GivePreviewCard.vue?vue&type=template&id=2e3dd82a&scoped=true&"
import script from "./GivePreviewCard.vue?vue&type=script&lang=js&"
export * from "./GivePreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./GivePreviewCard.vue?vue&type=style&index=0&id=2e3dd82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3dd82a",
  null
  
)

export default component.exports